export default function arrayMap(arrayOfCryptoIds) {
    var arr = Object.values(arrayOfCryptoIds).map((v) => ({
      id: v.id,
    }));
    arrayOfCryptoIds = arr.map(function (obj) {
      return obj.id;
    });
    return arrayOfCryptoIds;
}